import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import sv from "./sv.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { sv: { translation: sv }, en: { translation: en } },
    lng: "sv",
    fallbackLng: "sv",
    interpolation: { escapeValue: false },
  });

export default i18n;
